var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktokSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.5051937,8.161397V8.161273c-1.4814835-0.3153949-2.7930012-1.0891738-3.7791119-2.1654806 c-1.0252113-1.1195011-1.6983681-2.5662303-1.8440037-4.1656299V1.1735549h-5.1374683v20.3899994 c-0.0083981,2.3770256-1.9384604,4.3017921-4.3186312,4.3017921c-1.4025421,0-2.6486063-0.6682339-3.4377766-1.7034149H8.988533 c-0.5727835-0.7506504-0.8823452-1.6689091-0.8809376-2.6131077c0-2.383564,1.9333296-4.3161907,4.3186312-4.3161907 c0.4445238-0.000124,0.8863993,0.0679359,1.310029,0.2022781v-5.2190981 c-0.4950829-0.067812-0.9947577-0.0966082-1.4941854-0.0860577l-0.0002069,0.000082 C7.1195807,12.2356319,3,16.4188461,3,21.5636368c0,2.5681744,1.0258303,4.8963795,2.6907663,6.5975189l0.0000415,0.000042 c0.0000415,0.0000401,0.0000415,0.0000401,0.0000415,0.0000401C7.4052277,29.9131851,9.795949,31,12.4409142,31 c5.2142162,0,9.44137-4.2245064,9.44137-9.4362392V11.1462927C23.8883495,12.5794506,26.345808,13.422739,29,13.422739V8.317709 C28.4976768,8.3177919,27.9966354,8.2654533,27.5051937,8.161397z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokSmall);
export default __webpack_public_path__ + "static/media/tiktok--small.2dbaf3dcb58501c8ebaa9fb76ca9ad06.svg";
export { ForwardRef as ReactComponent };